export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_02.c836b8f4.jpg";